import { render, staticRenderFns } from "./page-meta.vue?vue&type=template&id=5c702e5b&"
import script from "./page-meta.vue?vue&type=script&lang=js&"
export * from "./page-meta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports